module.exports = __webpack_public_path__ + "img/Add.b4c1a8d2.svg";